import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { KindergartenDayOffRead } from '@isophi/mng-api';
import { isSameMonth } from 'date-fns';

import { MenuTypeEnum } from '../../../../core/enums/menu-type.enum';

@Component({
  selector: 'app-holidays-dates-row',
  templateUrl: './holidays-dates-row.component.html',
  styleUrls: ['./holidays-dates-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HolidaysDatesRowComponent {
  @Input() dayOff: KindergartenDayOffRead;

  @Output() refreshDaysOff = new EventEmitter();

  // eslint-disable-next-line @typescript-eslint/naming-convention
  MenuTypeEnum = MenuTypeEnum;

  isSameMonth = isSameMonth;
}
